"use client";

import Link from "next/link";

import { BlogThemeToggle } from "@/components/blog/BlogThemeToggle";
import { DeskBackButton } from "@/components/DeskBackButton";
import { ExpiryDeskWordmark } from "@/components/ExpiryDeskWordmark";

/**
 * Slim top chrome for /tools/* — matches dashboard theme tokens (not blog marketing chrome).
 */
export function ToolsHubHeader() {
  return (
    <header className="ed-tools-hub-header" aria-label="Tools">
      <div className="ed-tools-hub-header__inner">
        <div className="ed-tools-hub-header__left">
          <DeskBackButton fallbackHref="/tools" label="Back" />
          <Link href="/tools" className="ed-tools-hub-header__pill">
            Tools
          </Link>
          <div className="ed-tools-hub-header__mark">
            <ExpiryDeskWordmark variant="nav" showTagline={false} href="/dashboard" linkClassName="ed-desk-brand-link" />
          </div>
        </div>
        <div className="ed-tools-hub-header__right">
          <BlogThemeToggle />
        </div>
      </div>
    </header>
  );
}
